import gql from "graphql-tag";

const getAppConfigOrganization = gql`
  query {
    getAppConfigOrganization {
      id
      logoUrl
      shortName
      name
      slogan
      address
      phone
      createdAt
      updatedAt
    }
  }
`;

const getMyAppInPlatform = gql`
  query {
    getMyAppInPlatform {
      id
      url
      iconUrl
      name
      description
      openNewTab
      userCanAccess {
        id
        username
        fullname
        email
      }
      createdAt
      updatedAt
    }
  }
`;

export default { getAppConfigOrganization, getMyAppInPlatform };
